import { Button } from 'react-bootstrap'

import DropdownMenu from '../../../Components/DropdownMenu'

const getActiveRequest = (type, reqs) => {
  return reqs.find(req => req.reqType === type && (!req.statusUpdates || req.statusUpdates[0].status === 'pending'))
}
const getApprovedRequest = (type, reqs) => {
  return reqs.find(req => req.reqType === type && req.statusUpdates && req.statusUpdates[0].status === 'approved')
}
export const PackageActionsMenu = ({
  canDeletePackage,
  pkg,
  pkgReqs,
  handleReq,
  handleCancelReq,
  setItemToUnite,
  setItemToReturn,
  onDeletePackage,
}) => {
  const activeUniteReq = pkgReqs.find(
    req => req.reqType === 'uniteRequest' && req.unitePackageIds?.includes(pkg.id) && req.statusUpdates?.[0]?.status === 'pending'
  )
  const activeReturnReq = pkgReqs.find(
    req =>
      req.reqType === 'returnRequest' &&
      (!req.statusUpdates ||
        req.statusUpdates[0].status === 'pending' ||
        (req.statusUpdates[0].status === 'rejected' && req.statusUpdates[0].reason === 'falseLabel'))
  )
  const activeShrinkReq = getActiveRequest('shrinkRequest', pkgReqs)
  const activePhotoReq = getActiveRequest('photoRequest', pkgReqs)

  const approvedPhotoReq = getApprovedRequest('photoRequest', pkgReqs) || (pkg.photo ? { photo: pkg.photo } : null)
  const approvedShrinkReq = getApprovedRequest('shrinkRequest', pkgReqs) || pkg.isShrinkRequestApproved
  const allowedShrinkWarehouses = ['USA', 'UK']
  const allowShrinkGr = pkg.warehouse === 'GR' && pkg.contents.some(c => c.productCategory === 'Shoes')
  return (
    <DropdownMenu
      dropdownContent={
        <>
          {!pkg.isShipped && !pkg.isPaid && !pkg.isReturned && (
            <>
              <button
                className='text-center'
                disabled={activeReturnReq || activePhotoReq || activeShrinkReq}
                title={activeReturnReq || activePhotoReq || activeShrinkReq ? 'Other request active' : ''}
                onClick={() => (activeUniteReq ? handleCancelReq(activeUniteReq) : setItemToUnite(pkg))}
              >
                Unite {activeUniteReq ? '- Cancel' : ''}
              </button>
              <button
                className='text-center'
                disabled={activeUniteReq || activePhotoReq || activeShrinkReq}
                title={activeUniteReq || activePhotoReq || activeShrinkReq ? 'Other request active' : ''}
                onClick={() => (activeReturnReq ? handleCancelReq(activeReturnReq) : setItemToReturn(pkg))}
              >
                Return {activeReturnReq ? '- Cancel' : ''}
              </button>
              <button
                className='text-center'
                disabled={activeReturnReq || approvedPhotoReq?.photo}
                title={approvedPhotoReq?.photo ? 'Photo sent' : activeReturnReq ? 'Return request active' : ''}
                onClick={() => (activePhotoReq ? handleCancelReq(activePhotoReq) : handleReq('photoRequest', pkg))}
              >
                Photo {activePhotoReq ? '- Cancel' : ''}
              </button>
              {approvedShrinkReq ? (
                <button disabled className='text-center'>
                  Shrink completed
                </button>
              ) : (
                (allowedShrinkWarehouses.includes(pkg.warehouse) || allowShrinkGr) && (
                  <button
                    className='text-center'
                    disabled={activeReturnReq}
                    title={activeReturnReq ? 'Return request active' : ''}
                    onClick={() => (activeShrinkReq ? handleCancelReq(activeShrinkReq) : handleReq('shrinkRequest', pkg))}
                  >
                    Shrink {activeShrinkReq ? '- Cancel' : ''}
                  </button>
                )
              )}
            </>
          )}
          {canDeletePackage && (
            <Button onClick={() => onDeletePackage(pkg)} color='danger' variant='primary' className='delete-package-button btn-danger btn'>
              Delete Package
            </Button>
          )}
        </>
      }
    />
  )
}
